module.exports = __webpack_public_path__ + "media/images/svg/post-it-9fe45e6148b3d78f785158e19658bb7f.svg";